{
	"imprintTitle": "Avtrykk",
	"termsAndConditionsTitle": "Vilkår og betingelser",
	"privacyPolicyTitle": "Personvernerklæring",
	"openSourceAttributionTitle": "Åpen kildekode-attribusjon"
}
